import React, { useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';

let initialOptions = [
  { value: 'per_unit', label: 'Per Unit' },
  { value: 'tiered', label: 'Tiered' },
];

const DueAfterInput = ({ formData, onChange, disabled = false }) => {
  const [options, setOptions] = useState(initialOptions);

  const handleChange = (e) => {
    let updateData = {
      ...formData,
      due_after: parseInt(e.target.value, 10),
    };

    onChange(updateData);
  };

  return (
    <TextField
      label="Due After"
      type="number"
      placeholder={'0'}
      value={formData.due_after}
      onChange={(e) => onChange({ ...formData, due_after: parseInt(e.target.value) })}
      size="small"
      fullWidth
      disabled={disabled}
      slotProps={{
        input: {
          endAdornment: <InputAdornment position="end">Days</InputAdornment>,
        },
        inputLabel: {
          shrink: true,
        },
      }}
    />
  );
};

export default DueAfterInput;
